<template>
  <span
    class="app-icon"
    :style="{
      width: getParsedValue(size || width),
      height: getParsedValue(size || height),
    }"
    v-html="icon"
  />
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: [String, Number],
    default: 0
  },
  width: {
    type: [String, Number],
    default: '24'
  },
  height: {
    type: [String, Number],
    default: '24'
  },
  color: {
    type: String
  },
  isFillColor: {
    type: Boolean,
    default: false
  }
})

const icon = ref(null)

async function getIcon() {
  try {
    const iconsImport = import.meta.glob('../../assets/icons/**/*.svg')
    const path = `../../assets/icons/${props.name}.svg`

    if (!iconsImport[path]) {
      throw new Error(`Icon "${props.name}" does not exist in /assets/icons`)
    }

    const raw = await import(`../../assets/icons/${props.name}.svg?raw`)
    let svgText = raw.default

    svgText = svgText.replace(
      /<svg\b([^>]*)>/i,
      (m, attrs) =>
        `<svg ${attrs
          .replace(/\s+(width|height)="[^"]*"/gi, '')
          .trim()
        }>`
    )

    const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml')
    const svgEl = doc.documentElement

    if (props.color) {
      const paths = svgEl.querySelectorAll('path')
      paths.forEach(p => {
        if (props.isFillColor) {
          if (p.getAttribute('fill') !== 'none') p.setAttribute('fill', props.color)
        } else {
          p.setAttribute('stroke', props.color)
        }
      })
    }

    svgText = new XMLSerializer().serializeToString(svgEl)
    icon.value = svgText
  } catch (e) {
    console.error(e?.message || e)
  }
}

await getIcon()
watchEffect(getIcon)
</script>

<style lang="scss" scoped>
.app-icon {
  display: inline-block;
  position: relative;
  overflow: hidden;
  transition: .2s ease-in-out;

  :deep(svg) {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
